// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Loader.css */
.loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6); /* Fondo oscuro con transparencia */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999; /* Asegura que esté encima de todo */
  }
  
  .spinner {
    border: 16px solid #f3f3f3; /* Gris claro */
    border-top: 16px solid #3498db; /* Azul */
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 1.5s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/provicionamiento-componentes/Maintenance/Maintenance-styles/Loader.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oCAAoC,EAAE,mCAAmC;IACzE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,oCAAoC;EACrD;;EAEA;IACE,0BAA0B,EAAE,eAAe;IAC3C,8BAA8B,EAAE,SAAS;IACzC,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,oCAAoC;EACtC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC","sourcesContent":["/* Loader.css */\n.loader-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.6); /* Fondo oscuro con transparencia */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999; /* Asegura que esté encima de todo */\n  }\n  \n  .spinner {\n    border: 16px solid #f3f3f3; /* Gris claro */\n    border-top: 16px solid #3498db; /* Azul */\n    border-radius: 50%;\n    width: 120px;\n    height: 120px;\n    animation: spin 1.5s linear infinite;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
